export enum Church {
    ADBELEM = "A",
    OTHER = "O"
}